/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { Observable } from 'rxjs';

import { map, startWith } from 'rxjs/operators';
import { ApiService } from '@app/@core/services';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'associates-nominee-add-dialog',
  templateUrl: './nominee-add-dialog.component.html',
  styleUrls: ['./nominee-add-dialog.component.scss'],
})
export class AssociatesNomineeAddDialogComponent implements OnInit {
  constructor (
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    public dialogRef: MatDialogRef<AssociatesNomineeAddDialogComponent>) {

  }

  ngOnInit() {
    this.addRow();
  }

  processing = false;
  authForm = this.formBuilder.group({
    nominee_list: this.formBuilder.array([])
  });

  get nominee_list(): FormArray {
    return <FormArray>this.authForm.controls.nominee_list;
  }

  resetForm(ref = null) {
    if (!ref) {
      this.authForm.reset();
    } else {
      const form_field = this.authForm.get(ref);
      if (!form_field.validator) return form_field.reset();

      const validator = form_field.validator({} as AbstractControl);
      if (validator && validator.required) form_field.setValue('');
      else form_field.reset();
    }
  }

  nomineesCount() {
    let count = 0;
    this.nominee_list.controls.forEach((ctrl) => {
      if (ctrl.valid) count++;
    });
    return count;
  }

  submitForm() {
    this.processing = true;
    let nominee_array = [];
    this.nominee_list.controls.forEach((ctrl) => {
      if (ctrl.valid) nominee_array.push(ctrl.value);
    });
    // console.log(nominee_array);
    // let form_data = new FormData();
    // form_data.append("nominees", JSON.stringify(nominee_array));
    // Create Nominees
    let url = "associates/clients/" + this.data.client_uuid + "/nominees";
    this.apiService.post(url, {'nominees': JSON.stringify(nominee_array)}).subscribe((res) => {
      // console.log("POST clients", res);
      if (res.error === false) {
        // Client Created
        this.dialogRef.close(res);
      }

      this.processing = false;
    });
  }

  addRow() {
    if (this.authForm.valid) this.nominee_list.push(this.row_default());
  }

  removeRow(rowIndex) {
    this.nominee_list.removeAt(rowIndex);
  }

  row_default() {
    return this.formBuilder.group({
      full_name: ['', Validators.required],
      mobile_no: ['', Validators.required],
      nominee_benefit_slug: ['benefit', Validators.required],
    });
  }
}